import * as React from "react";
import styled from "styled-components";

export interface Stepper {
    step: number;
    steps?: number;
    onClick: (step: number) => () => void;
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  top: -25px;
  height: 14px;
  z-index: 30000;
  position: relative;
  user-select: none;
`;

const Ball = styled.div<{ selected: boolean }>`
  margin: 0 8px;
  min-width: 12px;
  width: 12px;
  height: 12px;
  min-height: 12px;
  cursor: pointer;
  border-radius: 50%;
  background-color: ${({ selected }) => (selected ? "#1b576a" : "#e3e2e2")};
`;

export function Stepper({ step, steps, onClick }: Stepper) {
    return (
        <Wrapper>
            {Array.from(new Array(steps)).map((_, i) => (
                <Ball onClick={onClick(i)} selected={i === step} />
            ))}
        </Wrapper>
    );
}
